import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useDynamicFavicon(): void {
  const location = useLocation();

  useEffect(() => {
    const isAdmin = location.pathname.startsWith("/admin");
    const href = isAdmin
      ? "/admin-logo-reverse-filled.svg"
      : "/logo-reverse-filled.svg";

    let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      link.type = "image/svg+xml";
      document.head.appendChild(link);
    }
    // Avoid unnecessary DOM writes
    const targetHref = `${window.location.origin}${href}`;
    if (link.href !== targetHref) {
      link.type = "image/svg+xml";
      link.href = href;
    }
  }, [location.pathname]);
}
